// extracted by mini-css-extract-plugin
export default {"colorShuttleGrey":"#5C6770","colorBlueRibbon":"#2B5FF5","root":"AtgFXjgS_78xo4PObIWr","content":"ccFZm8H2BwM0d7ROEP71","selected":"SQT39rvvQ2UZ8_Ge69c3"};